import React from "react";
import { useLocation, Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { whatsappLink } from "../data/config";

export function WhatsAppButton() {
  return (
    <a
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed left-4 bottom-4 md:bottom-6 z-40 flex items-center justify-center w-14 h-14 rounded-full bg-health hover:bg-[#0ea271] shadow-[0_8px_30px_rgba(16,185,129,0.4)] transition-all hover:scale-105"
      aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp"
    >
      <MessageCircle size={26} className="text-white" />
    </a>
  );
}

// Always-visible quote CTA on mobile.
export function MobileQuoteBar() {
  const location = useLocation();
  if (location.pathname === "/quote") return null;
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 p-3 bg-navy-900/90 backdrop-blur-md border-t border-white/10" data-testid="mobile-quote-bar">
      <Link
        to="/quote"
        className="flex items-center justify-center w-full py-3.5 rounded-md bg-cta hover:bg-cta-dark text-white font-semibold transition-colors"
        data-testid="mobile-quote-bar-cta"
      >
        Get My Quote
      </Link>
    </div>
  );
}

export default WhatsAppButton;
